import { apis } from '@/config';
import { api } from '@/api/api';
class MailStrangerApiImpl {
    constructor() {
        this.name = apis.mailStrangerApiImpl;
        this.systemApi = api.getSystemApi();
        this.http = api.getDataTransApi();
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.mailConfigApi = api.requireLogicalApi(apis.mailConfApiImpl);
    }
    init() {
        return this.name;
    }
    static getCommonRes(resData, handleData) {
        if (resData === null || resData === void 0 ? void 0 : resData.success) {
            let { data } = resData;
            if (handleData && data) {
                data = handleData(data);
            }
            return {
                data,
                success: true,
            };
        }
        return {
            success: false,
            message: resData === null || resData === void 0 ? void 0 : resData.message,
        };
    }
    static async handlePromise(promise, handleData) {
        try {
            const res = await promise;
            const data = res.data;
            return MailStrangerApiImpl.getCommonRes(data, handleData);
        }
        catch (e) {
            return {
                success: false,
            };
        }
    }
    async getSmartGetPriorities(params) {
        var _a;
        const url = this.systemApi.getUrl(params.email ? 'getSmartGetPriority' : 'getSmartGetPriorities');
        const dealedParams = Object.assign(Object.assign({}, params), (params.email ? { email: (_a = params.email) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase() } : null));
        const res = await MailStrangerApiImpl.handlePromise(this.http.get(url, dealedParams, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        }));
        return res;
    }
    async setSmartPriorities(req) {
        var _a;
        const url = this.systemApi.getUrl('setSmartPriorities');
        const { email, priority, name, prevPriority } = req;
        try {
            if (prevPriority !== undefined) {
                this.trackApi.track('pc_intelligent_display_sender_importance', {
                    display_mode: this.mailConfigApi.getMailMergeSettings() === 'true' ? '聚合模式' : '普通模式',
                    original_state: prevPriority,
                    operating_actions: priority,
                });
            }
        }
        catch (error) {
            console.warn('[hubble] pc_intelligent_display_sender_importance report error');
        }
        const emails = typeof email === 'string' ? [email] : email;
        let requestEmails = emails.slice();
        let names = [];
        if (typeof name === 'string') {
            names = [name];
        }
        else if (Array.isArray(name)) {
            names = [...name];
        }
        if (names.length === emails.length) {
            requestEmails = emails.map((e, index) => {
                const n = names[index];
                if (n) {
                    return `"${n}"<${e}>`;
                }
                return e;
            });
        }
        const res = await MailStrangerApiImpl.handlePromise(this.http.post(url, {
            priority,
            email: requestEmails.join(','),
        }));
        if (res.success) {
            try {
                await this.mailApi.newUsersIntoEmailList(emails.map(item => ({
                    accountName: item,
                    priority,
                })), 'mark');
                await this._syncContact({ priority, email: emails, contacts: (_a = res.data) === null || _a === void 0 ? void 0 : _a.contacts });
            }
            catch (error) {
                console.warn('[setSmartPriorities] after process error');
            }
        }
        return res;
    }
    async _syncUpdateContact(emails, priority) {
        const localContacts = await this.contactApi.doGetContactByItem({
            type: 'EMAIL',
            value: emails,
        });
        if (localContacts.length > 0) {
            await this.contactApi.doUpdateContactModel(localContacts.map(contact => (Object.assign(Object.assign({}, contact), { contact: Object.assign(Object.assign({}, contact.contact), { priority }) }))));
        }
    }
    async _syncContact(req) {
        var _a;
        const { contacts, email, priority } = req;
        let updateEmails = [...email];
        if (Array.isArray(contacts) && contacts.length > 0) {
            await this.mailApi.doMarkMailPerferred(req.email, req.priority, 'new');
            const emailPools = contacts.flatMap(c => c.email);
            updateEmails = email.filter(em => !emailPools.includes(em));
            await this.contactApi.doInsertOrReplacePersonal({
                data: {
                    data: contacts,
                    success: true,
                },
                _account: ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
            });
        }
        else {
            await this.mailApi.doMarkMailPerferred(req.email, req.priority, 'edit');
        }
        await this._syncUpdateContact(updateEmails, priority);
    }
}
const mailStrangerApiImpl = new MailStrangerApiImpl();
api.registerLogicalApi(mailStrangerApiImpl);
export default mailStrangerApiImpl;
